$(function(){
  const mvSwiper = new Swiper('.topicsWrap .sliderWrap.swiper', {
    slidesPerView: 1,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });
  const productSwiper = new Swiper('.topicsWrap .productSlider.swiper', {
    slidesPerView: 'auto',
    loop: false
  });
});